import React from 'react';
import { Link } from 'react-router-dom';
import { isSupportChatLoaded, openSupportChat } from '../../../../utils/chat';
import { useCookiePreferences } from '../../../../utils/cookiePreferences';
import { FOOTER_LINK_ACTIONS } from './utils/footerLinks';

const LINK_CLASS_NAME = 'sbf-link gRegular';

// Action links (chat, cookie settings) are real anchors whose `to` is where
// they go if the action can't run; the click handler replaces that when it can.
function FooterLink({ link }) {
  const { openCookiePreferences } = useCookiePreferences();
  const { label, to, href, action } = link;

  if (action) {
    const actionHandlers = {
      [FOOTER_LINK_ACTIONS.CHAT]: openSupportChat,
      [FOOTER_LINK_ACTIONS.COOKIE_SETTINGS]: openCookiePreferences,
    };
    const handleActionClick = (event) => {
      if (action === FOOTER_LINK_ACTIONS.CHAT && !isSupportChatLoaded()) {
        return;
      }
      event.preventDefault();
      actionHandlers[action]();
    };

    return (
      <a href={to} className={LINK_CLASS_NAME} onClick={handleActionClick}>
        {label}
      </a>
    );
  }

  if (href) {
    const isMailto = href.startsWith('mailto:');
    return (
      <a
        href={href}
        className={LINK_CLASS_NAME}
        {...(isMailto ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
      >
        {label}
      </a>
    );
  }

  return (
    <Link to={to} className={LINK_CLASS_NAME}>
      {label}
    </Link>
  );
}

export default FooterLink;
